/// <reference path='dapi.d.ts' />
/**
* Publishes the context actions contained in this head.
* @param head
* @param dapi
* @returns {}
*/
export default function publishContextActions(head, dapi) {
    const ctxActionLinks = head.querySelectorAll("link[rel='ctxaction']");
    const contextActions = [];
    for (let i = 0; i < ctxActionLinks.length; i++) {
        contextActions.push({
            href: ctxActionLinks[i].attributes["href"] ? ctxActionLinks[i].attributes["href"].value : undefined,
            title: ctxActionLinks[i].attributes["title"] ? ctxActionLinks[i].attributes["title"].value : undefined,
            icon: ctxActionLinks[i].attributes["data-icon"] ? ctxActionLinks[i].attributes["data-icon"].value : undefined
        });
    }
    if (contextActions.length > 0)
        dapi.setContextActions(contextActions);
}
